"use strict";
// Shared client-side diff helper for the Update vs Correction edit flow.
// Computes a list of changed fields between an "original" snapshot (DB state)
// and a "candidate" snapshot (form state) so the EditClassificationDialog can
// present per-field old vs new and capture per-field classifications.
//
// Mirrors the backend rule: ignore `_id` keys at any depth, since mongoose
// regenerates subdocument _ids when arrays are reassigned.
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeFieldDiff = computeFieldDiff;
// Normalize for diff: treat null, undefined and "" as the same "empty" value;
// strip `_id` at any depth; convert dates to ISO strings; recursively drop
// empty entries from objects so `{a: ""}` and `{}` compare equal.
function isEmpty(v) {
    return v === null || v === undefined || v === "";
}
function normalize(v) {
    if (isEmpty(v))
        return null;
    if (v instanceof Date)
        return v.toISOString();
    if (Array.isArray(v))
        return v.map(normalize);
    if (typeof v === "object") {
        var out = {};
        for (var _i = 0, _a = Object.entries(v); _i < _a.length; _i++) {
            var _b = _a[_i], k = _b[0], val = _b[1];
            if (k === "_id")
                continue;
            var n = normalize(val);
            if (n !== null)
                out[k] = n;
        }
        return out;
    }
    return v;
}
function deepEqual(a, b) {
    return JSON.stringify(normalize(a)) === JSON.stringify(normalize(b));
}
function prettifyKey(key) {
    // tradingAsName -> Trading As Name
    return key
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/^./, function (c) { return c.toUpperCase(); })
        .replace(/\s+/g, " ")
        .trim();
}
function computeFieldDiff(before, after, fields) {
    var _a;
    var result = [];
    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
        var f = fields_1[_i];
        var oldV = before ? before[f.key] : undefined;
        var newV = after[f.key];
        if (!deepEqual(oldV, newV)) {
            result.push({
                field: f.key,
                label: (_a = f.label) !== null && _a !== void 0 ? _a : prettifyKey(f.key),
                group: f.group,
                oldValue: oldV !== null && oldV !== void 0 ? oldV : null,
                newValue: newV !== null && newV !== void 0 ? newV : null,
            });
        }
    }
    return result;
}
